package com.exura.pages.planCreator.components.seriesViews.inputs

import androidx.compose.runtime.*
import com.exura.ui.*
import com.exura.ui.modifiers.ShadeBorder
import com.exura.ui.modifiers.insetHoverableItemStyle
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.readOnly
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.TextArea

@Composable
fun PlanCreatorTextArea(
    value: String,
    onValueChange: (String) -> Unit,
    mode: PlanCreatorInputMode,
    placeholder: String = "",
    modifier: Modifier = Modifier,
    textStyle: String = TextStyles.normal14,
    textHeight: CSSLengthNumericValue = 14.px,
    maxLines: Int = 3
) {
    val textAreaHeight = (textHeight + 4.px) * maxLines + 2 * 8.px
    var isSelected by remember { mutableStateOf(false) }
    var isFocused by remember { mutableStateOf(false) }

    val isInteractive = mode == PlanCreatorInputMode.EDIT
    val showPlaceholder = value.isEmpty() && !isFocused

    Box(
        modifier = Modifier
            .insetHoverableItemStyle(
                isSelected = isSelected && isInteractive,
                shadeColor = ExuraColors.BLUE.copy(alpha = 0.1),
                shadeSize = 16.px,
                shadeBorders = listOf(ShadeBorder.TOP, ShadeBorder.LEFT),
                cursor = if (isInteractive) Cursor.Text else Cursor.Default,
                onClick = if (isInteractive) {
                    { isSelected = true }
                } else null,
                isHoverable = isInteractive
            )
            .height(textAreaHeight)
            .borderRadius(4.px)
            .padding(8.px)
            .then(modifier),
        contentAlignment = Alignment.TopStart
    ) {
        TextArea(
            attrs = Modifier
                .fillMaxWidth()
                .backgroundColor(Colors.Transparent)
                .border(width = Dimens.spacingNone)
                .outline(
                    width = Dimens.spacingNone,
                    style = LineStyle.None,
                    color = Colors.Transparent
                )
                .padding(leftRight = 12.px, topBottom = 8.px)
                .classNames(textStyle)
                .color(if (showPlaceholder) ExuraColors.ARSENIC2 else ExuraColors.ARSENIC)
                .resize(Resize.None)
                .transition(
                    Transition.of(
                        property = HtmlProperties.ALL,
                        duration = 0.2.s,
                        timingFunction = AnimationTimingFunction.EaseInOut
                    )
                )
                .toAttrs {
                    value(if (showPlaceholder) placeholder else value)
                    if (isInteractive) {
                        onInput {
                            if (!showPlaceholder) {
                                onValueChange(it.value)
                            }
                        }
                        onFocus {
                            isFocused = true
                            isSelected = true
                        }
                        onBlur {
                            isFocused = false
                            isSelected = false
                        }
                    } else {
                        readOnly()
                    }
                }
        )
    }
}
